import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "botbit-ui-components";
import './LocalSeoStoreChartModal.scss';
import { GoogleMapsIcon } from '../../localSeoStoreChart/LocalSeoStoreChartIcons';
import translate from '../../../../config/translations/translate';
import DashboardPeriodSelector from '../../dashboardPeriodSelector/DashboardPeriodSelector';
import LocalSeoStoreChart from '../../localSeoStoreChart/LocalSeoStoreChart';


const LocalSeoStoreChartModalComponent = ({store, isOpen, toggle, selectedPeriod, t }) => {
    const [placeId, setPlaceId] = useState(null);

    const TIME_PERIOD_OPTIONS = [
        { value: 'LAST_30_DAYS', label: t('timePeriod.options.LAST_30_DAYS') },
        { value: 'PAST_MONTH', label: t('timePeriod.options.PAST_MONTH') },
        { value: 'LAST_3_MONTHS', label: t('timePeriod.options.LAST_3_MONTHS') },
        { value: 'LAST_6_MONTHS', label: t('timePeriod.options.LAST_6_MONTHS') },
        { value: 'LAST_12_MONTHS', label: t('timePeriod.options.LAST_12_MONTHS') },
        { value: 'THIS_YEAR', label: t('timePeriod.options.THIS_YEAR') }
    ];

    return (
        <div className={isOpen ? "local-seo-chart-modal-container" : ""}>
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} >
                    <div className='local-seo-chart-modal-header-container'>
                        <h2 className="local-seo-chart-modal-header-title">
                            {store && ((store.storeName || store.name) || t('noStoreSelected'))}
                        </h2>
                        <div className='local-seo-chart-modal-period-selector-container'>
                            <DashboardPeriodSelector 
                                timePeriodOptions={TIME_PERIOD_OPTIONS}
                                t={t}
                                selectedPeriod={selectedPeriod}
                                handlePeriodChange={()=>{}}
                                readOnly
                            />
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="local-seo-chart-header-container-modal">
                        <div className="local-seo-icon-and-subtitle">
                            <div className="google-maps-icon">
                                <GoogleMapsIcon />
                            </div>
                            <h4 className="google-maps-subtitle-modal">
                                {t('googleMapsRanking')}
                            </h4>
                            {(placeId !== null) && <img src="/static/img/GooglePlaceIcon.svg" 
                                alt="Google Place Icon" 
                                style={{width: "30px", height: "30px", marginLeft: "10px", cursor: "pointer"}} 
                                onClick={() => {
                                    window.open(`https://www.google.com/maps/place/?q=place_id:${placeId}`, '_blank');
                                }}
                            />}
                        </div>
                    </div>
                    <LocalSeoStoreChart 
                        store={store}
                        selectedPeriod={selectedPeriod}
                        t={t}
                        setPlaceId={setPlaceId}
                    />
                </ModalBody>
                <ModalFooter>
                    <button className="close-modal-button-local-seo-chart-modal" onClick={toggle}>
                        {t('close')}
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

LocalSeoStoreChartModalComponent.translations = {
    noStoreSelected: {
        es: "No hay tienda seleccionada",
        en: "No store selected"
    },
    googleMapsRanking: {
        es: "Ranking en Google Maps",
        en: "Google Maps Ranking"
    },
    close: {
        es: "Cerrar",
        en: "Close"
    },
    timePeriod: {
        label: {
            es: "Período de tiempo",
            en: "Time period",
        },
        options: {
            LAST_7_DAYS: {
            es: "Últimos 7 días",
            en: "Last 7 days",
            },
            LAST_30_DAYS: {
            es: "Últimos 30 días",
            en: "Last 30 days",
            },
            THIS_MONTH: {
            es: "Este mes",
            en: "This month",
            },
            PAST_MONTH: {
              es: "Mes pasado",
              en: "Past month",
            },
            LAST_3_MONTHS: {
            es: "Últimos 3 meses",
            en: "Last 3 months",
            },
            LAST_6_MONTHS: {
            es: "Últimos 6 meses",
            en: "Last 6 months",
            },
            LAST_12_MONTHS: {
            es: "Últimos 12 meses",
            en: "Last 12 months",
            },
            THIS_YEAR: {
            es: "Este año",
            en: "This year",
            },
        }
    },
    metrics: {
        visits: {
            es: "Visitas",
            en: "Visits"
        },
        walkIns: {
            es: "Visitas a la tienda",
            en: "Walk-ins"
        },
        websiteClicks: {
            es: "Clics al sitio web",
            en: "Website Clicks"
        },
        orders: {
            es: "Pedidos",
            en: "Orders"
        },
        menuClicks: {
            es: "Clics al menú",
            en: "Menu Clicks"
        },
        calls: {
            es: "Clics al teléfono",
            en: "Phone Clicks"
        },
        bookings: {
            es: "Reservas",
            en: "Bookings"
        },
        engagementRate: {
            es: "Tasa de interacción",
            en: "Eng. Rate"
        }
    },
    columns: {
        comparisonTooltip: {
            es: "Esta comparación muestra el porcentaje de cambio entre el período y el mismo período del año anterior. Ejemplo: El mes pasado compara abril 2025 con abril 2024. Si no hay suficientes datos para el período anterior, esta comparación se ocultará.",
            en: "This comparison shows the percent of change between the period and the same period the year before. Example: Last month compares April 2025 with April 2024. If there is not enough data for the previous period, this comparison will be hidden."
        },
        noDataComparisonTooltip: {
            es: "Esta comparación no aplica, ya sea porque no hay datos suficientes o porque el periodo a comparar en esta métrica suma 0.",
            en: "This comparison does not apply, either because there is not enough data or because the previous period sum of values equals 0."
        }
    },
    months: {
        january: {
            es: "Enero",
            en: "January"
        },
        february: {
            es: "Febrero",
            en: "February"
        },
        march: {
            es: "Marzo",
            en: "March"
        },
        april: {
            es: "Abril",
            en: "April"
        },
        may: {
            es: "Mayo",
            en: "May"
        },
        june: {
            es: "Junio",
            en: "June"
        },
        july: {
            es: "Julio",
            en: "July"
        },
        august: {
            es: "Agosto",
            en: "August"
        },
        september: {
            es: "Septiembre",
            en: "September"
        },
        october: {
            es: "Octubre",
            en: "October"
        },
        november: {
            es: "Noviembre",
            en: "November"
        },
        december: {
            es: "Diciembre",
            en: "December"
        }
    }
};

export const LocalSeoStoreChartModal = translate(LocalSeoStoreChartModalComponent);